import React, { Suspense } from 'react'
import { lazyWithRetry } from '../../helper/lazyWithRetry'
import PageLoader from '../../component/Elements/pageLoader'

const WebShopPreOrders = lazyWithRetry(() => import(/* webpackChunkName: "webshop-pre-orders" */'../../component/WebShopPreOrders'))

const WebShopPreOrdersPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<WebShopPreOrders />
		</Suspense>
	)
})

WebShopPreOrdersPage.displayName = 'WebShopPreOrdersPage'
export default WebShopPreOrdersPage
